export enum ICON_COLOR {
    LIGHT,
    DARK,
}
